<div class="chat-window">
  <div class="input-group">
    <div class="form-control p-t-0 p-b-0">
      <div class="fs-5 fw-bold header-text">{{pageTitle}}</div>
      <div class="small fst-italic">This conversation is powered by AI and can make mistakes.</div>
    </div>
    <span class="input-group-text header-button" (click)="clickClearChat()" title="Clear"><i class="icon feather icon-refresh-cw"></i></span>
    <span class="input-group-text header-button" (click)="navToggleChat()" title="Close"><i class="fa fa-times"></i></span>
  </div>
  <div class="chatbox">
    <div *ngFor="let chat of chatDisplay" class="mt-1 mb-1" [ngClass]="{ 'message-user' : chat.isUser, 'message-bot' : !chat.isUser }">
      <div class="p-1" *ngIf="!chat.isUser">
        <span><i class="fa fa-comment"></i></span>
      </div>
      <div class="p-2 message-bot-text" *ngIf="!chat.isUser" [innerHtml]="chat.message"></div>
      <div class="p-2 message-user-text" *ngIf="chat.isUser">{{chat.message}}</div>
      <div class="p-1" *ngIf="chat.isUser">
        <span><i class="fa fa-user"></i></span>
      </div>
      <div class="p-1" *ngIf="!chat.isUser && chat.message_id != ''">
        <span (click)="clickFeedback(chat, 1)"><i class="fa fa-thumbs-up chat-icon-pointer" [ngClass]="{ 'chat-icon-green' : chat.rating == 1 }"></i></span>
      </div>
      <div class="p-1" *ngIf="!chat.isUser && chat.message_id != ''">
        <span (click)="clickFeedback(chat, -1)"><i class="fa fa-thumbs-down chat-icon-pointer" [ngClass]="{ 'chat-icon-red' : chat.rating == -1 }"></i></span>
      </div>
    </div>
    <div class="mt-1 mb-1 message-bot" *ngIf="isProcessing">
      <div class="p-1">
        <span><i class="fa fa-comment"></i></span>
      </div>
      <div class="p-2 chat-loader">
      </div>
    </div>
    <div class="p-1 feedbackBox" *ngIf="!hideFeedbackBox">
      <span><i (click)="changeFeedback(1)" class="m-1 fa fa-thumbs-up chat-icon-pointer" [ngClass]="{ 'chat-icon-green' : feedbackRating == 1 }"></i></span>
      <span><i (click)="changeFeedback(-1)" class="m-1 fa fa-thumbs-down chat-icon-pointer" [ngClass]="{ 'chat-icon-red' : feedbackRating == -1 }"></i></span>
      <div class="input-group">
        <textarea maxlength="2000" rows="3" class="form-control" [(ngModel)]="feedbackComment" placeholder="Tell us about your experience."></textarea>
      </div>
      <button type="button" (click)="sendFeedback()" class="m-1 p-1 btn btn-primary">Send</button>
      <button type="button" (click)="closeFeedback()" class="m-1 p-1 btn btn-primary">Cancel</button>
    </div>
  </div>
  <div class="input-group">
    <textarea id="chatInputField" [(ngModel)]="inputMessage" [disabled]="isProcessing" class="form-control" placeholder="How can I help you?" (keydown.enter)="$event.preventDefault();sendMessage()"></textarea>
  </div>
</div>
